import { importMenu } from "./import-menu";
import { deliverySettings } from "./settings";
import { deliveryReport } from "./report";
import { deliveryMenus } from "./menus";
import { syncMenu } from "./sync-menu";

export const delivery = {
	goBack: "Retour",
	updateManyExternalIntegrations: {
		success: "Integrations mises jour avec succs",
	},
	externalStoreIntegrationStatus: {
		synced: "Synchronisé",
		pendingSyncing: "Synchronisation en attente",
		pendingImporting: "Importation en attente",
	},
	ordersManager: {
		title: "Gestionnaire de commandes",
		description:
			"Suivez et gérez les commandes qui arrivent d'Entregue já, Comanda Online et Pedido na mesa.",
		filter: {
			placeholder: "Filtrer par",
			orderStatus: "Statut de la commande",
			paymentMethod: "Méthode de paiement",
			orderOrigin: "Origine de la commande",
			appliedFilters: "filtre(s) appliqué(s)",
		},
		tabs: {
			newOrders: "Nouvelles commandes",
			completed: "Terminées",
		},
		loading: "Chargement",
		total: "Total: {{value}}",
		new: "Nouveau",
		emptyState: {
			title: "Nous n'avons pas encore de commandes {{status}}.",
			description:
				"Nous vous enverrons une notification lorsque vous recevrez une nouvelle commande.",
		},
	},
	orderStatuses: {
		placed: "En attente",
		confirmed: "Acceptées",
		dispatched: "En livraison",
		concluded: "Terminées",
		cancelled: "Annulées",
		pendingPayment: "Paiement en attente",
		ready: "Prêtes",
		pickupAreaAssigned: "Client sur place",
		scheduled: "Programmées",
	},
	deliverySettings,
	deliveryReport,
	deliveryMenus,
	syncMenu,
	importMenu,
};
